import GTMScript from "@/component/Ads/GTMScript";
import siteInfo from "@/constants/siteInfo";
import { getDataFromSSR } from "@/handlers/client/commonClient";
// import { useWindowSize } from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
// const SearchListing = dynamic(() => import("@/component/Listing/SearchList"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
// const NoData = dynamic(() => import("@/component/NoData"));
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
import { apstagBidCallback, createApsSlotsRosDesktop, createApsSlotsRosMobile, requestBiddingFromPWT } from "@/utils/ads";

const SearchPage = ({
  searchResultData = null,
  query = "",
  isMobileDevice = false,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [firstScroll, setFirstScroll] = useState(false);
  // const totalPages = searchResultData?.pagination_cap
  //   ? parseInt(searchResultData?.pagination_cap)
  //   : 10;

  const [searchData, setSearchData] = useState(searchResultData?.content);
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  // const totalPages = categoryNewsListData?.pagination_cap
  //   ? parseInt(categoryNewsListData?.pagination_cap)
  //   : 10;
  const router = useRouter();

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "20%",
  });

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getSearchListing?page=${currentPage}&query=${query}`
    );
    if (fetchedData?.data?.searchResultData?.content?.length > 0) {
      setSearchData([
        ...searchData,
        ...fetchedData?.data?.searchResultData?.content,
      ]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };

  useEffect(() => {
    const handleRouteChangeComplete = (url) => {
      setCurrentPage(0);
    };
    router.events.on("routeChangeComplete", handleRouteChangeComplete);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  useEffect(() => {
    setSearchData(searchResultData?.content);
  }, [searchResultData]);

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      if (!firstScroll) {
        setFirstScroll(true);
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (insightView && scrollDirection == "Scrolling Down" && hasMore) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView]);
  useEffect(() => {
    firstScroll && currentPage > 0 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
        {  !firstScroll&&  googletag.destroySlots();}
       { !firstScroll&&  googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());}
            if(firstScroll){
          if (searchResultData?.content?.length > 3) {
          document.getElementById("div-gpt-ad-1659434604998-0")&&  googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());
          }
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          }
     { !firstScroll&&    googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());}
            // googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();

          !firstScroll&&   googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

           INTERSTITIALAd && googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          
     if(!firstScroll){  googletag.destroySlots();   googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());}
            if(firstScroll){
          if (searchResultData?.content?.length > 9) {
          document.getElementById("div-gpt-ad-1707804176041-2")&&  googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
          }

          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());
          }
            // googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
        });
      }
     {firstScroll&& apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              :   createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );}
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [firstScroll]);
  // const size = useWindowSize();
  return (
    <section className="mx-4">
      <h1 className="hidden">{siteInfo?.siteName}</h1>
      <HeadTag
        title={searchResultData?.seo_detail?.meta_title}
        description={searchResultData?.seo_detail?.meta_description}
        keywords={searchResultData?.seo_detail?.meta_keyword}
        image={searchResultData?.seo_detail?.og_image}
        // canonicalUrl={
        //   process.env.NEXT_PUBLIC_WEBSITE_URL +
        //     searchResultData?.seo_detail?.canonical_url ?? "/customSearch"
        // }
        lcpImage={searchResultData?.content?.[0]?.image_small}
        robotFollow={false}
      />
      <GTMScript />
      <script id="itgd_searchScript" dangerouslySetInnerHTML={{__html: `const itg_SearchConfig = {
                template: 'at', /*fixed*/
                site: 'nwtak', /* Replace with the shortcode of your website */
                lang: 'hi', /* Choose the language of the website using the
            corresponding shortcode */
                contenttype: 'all',
                daterange: 'alldata',
                urlpattern: '/search/{keyword}', /* Modify to match your website's
            search results URL pattern */
                keyword: '${query}' /*page keyword*/
            };
            
            function loadSearchScript() {
                const remotePath = "https://akm-img-a-in.tosshub.com/sites/group-search/";
                const scriptURL = document.createElement("script");
                scriptURL.src = remotePath + "groupsearch_widget.js?t=" +
                    Math.random();
                scriptURL.defer = "defer";
                document.body.appendChild(scriptURL);
            }
            setTimeout(loadSearchScript, 1000);
            // loadSearchScript();
            `}}>
      </script>
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: "Search",
            canonical_url: "/search",
          },
        ]}
      />

      {/* <VDOAdsScript /> */}

      <div className="my-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="730px"
          minHeight="90px"
        />
      </div>
      <div id="itgd_generateSearch" className="my-4">
            <div class="widgetgap searchLoadingImg" style={{display:"grid",placeContent:"center",backgroundColor:"#eaeaea"}}>
              <img alt="Search widget" src="https://akm-img-a-in.tosshub.com/aajtak/resources/loading_at.gif"/>
            </div>
      </div>
      {/* <SearchListing
        searchResult={firstScroll ? searchData : searchResultData?.content}
        query={query}
        isMobileDevice={isMobileDevice}
      />
      <div
        className="text-sports news-load h-[50px] w-full mb-4"
        ref={insightref}
      >
        {loadingSpinner === true && (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
          </div>
        )}
      </div>
      {searchResultData?.content?.length === 0 &&
        searchData?.length &&
        searchResultData?.length === 0 && (
          <NoData message={`${query} से जुड़ी जानकारी सर्च में नहीं मिली.`} />
        )} */}
   { firstScroll&&  <AdSlot300x250
        divId="div-gpt-ad-1659435474737-0"
        minWidth="300px"
        minHeight="250px"
      />}
  { firstScroll&&   <AdSlot728x90
        divId="div-gpt-ad-1659425743360-0"
        minWidth="720px"
        minHeight="90px"
      />}
      {/* <Pagination
        handlePageClick={handlePageClick}
        currentPage={currentPage}
        totalPages={totalPages}
      /> */}
    </section>
  );
};

export default SearchPage;
